import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative',
    toggle:
      'group/toggle flex cursor-pointer items-center rounded-full group-data-[disabled]/toggle:cursor-not-allowed',
    switch:
      'bg-bg-medium-inactive group-hover/toggle:bg-blue-dark group-data-[checked]/toggle:bg-blue-dark group-data-[disabled]/toggle:bg-secondary-dark inline-flex h-6 w-10 items-center rounded-full transition-colors duration-200 group-data-[disabled]/toggle:cursor-not-allowed',
    dot: 'mx-[3px] size-4.5 rounded-full bg-white transition-transform duration-200 group-data-[checked]/toggle:translate-x-4',
    label:
      'text-main group-data-[disabled]/toggle:text-inactive cursor-pointer pl-2 font-light group-data-[disabled]/toggle:cursor-default',
    helperText: 'text-main mt-2 font-light'
  },
  variants: {
    checkedView: {
      default: '',
      checkedBackground: {
        toggle: 'data-[checked]:bg-blue-light p-[6px]'
      }
    },
    error: {
      true: {
        switch: 'bg-icon-heart group-data-[checked]/toggle:bg-icon-heart',
        helperText: 'text-error'
      }
    },
    color: {
      green: {
        switch: 'group-data-[checked]/toggle:bg-label-green'
      }
    }
  }
});
